import './demolegend.less'

import {classes} from '@codeurs/front'
import React from 'react'
import scrollIntoView from 'scroll-into-view-if-needed'
import {style} from 'util/style'

const styles = style('demolegend')

export const Demolegend: React.FC<{
	highlights: Array<string>
	mod?: 'light' | 'dark'
	toggleHighlight: (element: string) => void
}> = ({highlights, mod, toggleHighlight}) => {
	const demoLegendItems = [
		{key: 'demo', text: 'Demo stands'},
		{key: 'breakout', text: 'Breakouts'},
		{key: 'plenary', text: 'Plenary (Q. Elisabeth)'},
		{key: 'meeting', text: 'Meeting rooms'},
		{key: 'imecdesk', text: 'Info booth'},
		{key: 'lounge', text: 'Lounge areas'},
		{key: 'toiletten', text: 'Restrooms'}
	] as const

	return (
		<div class={styles()}>
			<h3 class={styles('title')}>Highlight on map</h3>
			<div class={styles('items')}>
				{demoLegendItems.map(item => {
					return (
						<DemoLegendButton
							item={item}
							mod={mod}
							highlights={highlights}
							toggleHighlight={toggleHighlight}
						/>
					)
				})}
			</div>
		</div>
	)
}

export const DemoLegendButton: React.FC<{
	item: {key: string; text: string}
	mod?: 'light' | 'dark'
	highlights: Array<string>
	toggleHighlight: (element: string) => void
}> = ({item, mod, highlights, toggleHighlight}) => {
	const {key, text} = item

	return (
		<div className={styles('item')}>
			<a
				{...classes('demolegend-item-button', {
					mod,
					is: {active: highlights.find(h => h == key)}
				})}
				onClick={() => {
					toggleHighlight(key)
					const map = document.getElementById('Layer_1')
					if (map) {
						scrollIntoView(map, {
							behavior: 'smooth',
							scrollMode: 'if-needed',
							block: 'start',
							inline: 'nearest'
						})
					}
				}}
			>
				{text}
			</a>
		</div>
	)
}
